export default function designerAgreement({ next, store }) {
    if ( (!store.getters.isDesigner || (store.getters.isDesigner && store.getters["profile"].ndaAgreementAccepted))) {
        return next()
    } else if (store.getters.isDesigner && !store.getters["profile"].ndaAgreementAccepted) {
         return next({ name: "confidential" })
    }
    next()
}
